import {useEffect, useId, useState} from "react";
import {Button, Modal} from "react-bootstrap";
import SchedulerActionLabel from "./SchedulerActionLabel";
import SchedulerWorkerTagCloud from "./SchedulerWorkerTagCloud";

export default function SchedulerMobileAssignAction({
    disabled = false,
    fieldWorkerArray = [],
    isLoading = false,
    onConfirm,
    title,
    workerWorkloadCounts,
}) {
    const titleId = useId();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedWorkerId, setSelectedWorkerId] = useState("");

    useEffect(() => {
        if (!isOpen) {
            setSelectedWorkerId("");
        }
    }, [isOpen]);

    function closeDialog() {
        if (!isLoading) {
            setIsOpen(false);
        }
    }

    async function confirmAssignment() {
        if (!selectedWorkerId || disabled || isLoading) {
            return;
        }

        const didAssign = await onConfirm(selectedWorkerId);
        if (didAssign !== false) {
            setIsOpen(false);
        }
    }

    return (
        <>
            <Button
                className="scheduler-mobile-card-action scheduler-mobile-assign-trigger"
                type="button"
                variant="outline-primary"
                size="sm"
                disabled={disabled || isLoading}
                aria-busy={isLoading}
                title={title}
                onClick={(event) => {
                    event.stopPropagation();
                    setIsOpen(true);
                }}
            >
                <SchedulerActionLabel isLoading={isLoading}>Assign To</SchedulerActionLabel>
            </Button>
            <Modal
                className="scheduler-mobile-assign-modal"
                centered
                show={isOpen}
                onHide={closeDialog}
                onClick={(event) => event.stopPropagation()}
                aria-labelledby={titleId}
            >
                <Modal.Header closeButton={!isLoading}>
                    <Modal.Title id={titleId}>Assign To</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="scheduler-mobile-assign-help">
                        Select a worker for this job.
                    </p>
                    <SchedulerWorkerTagCloud
                        activeWorkerId={selectedWorkerId}
                        ariaLabel="Workers to assign"
                        fieldWorkerArray={fieldWorkerArray}
                        onChange={setSelectedWorkerId}
                        workerWorkloadCounts={workerWorkloadCounts}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        type="button"
                        variant="outline-secondary"
                        disabled={isLoading}
                        onClick={closeDialog}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        variant="primary"
                        disabled={!selectedWorkerId || disabled || isLoading}
                        aria-busy={isLoading}
                        onClick={confirmAssignment}
                    >
                        <SchedulerActionLabel isLoading={isLoading}>Confirm</SchedulerActionLabel>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
